module.exports = __webpack_public_path__ + "img/macroad.cb5f81e7.jpg";